import { useRef, useEffect } from 'react';
import { AreaChart, Area, ResponsiveContainer, Tooltip } from 'recharts';
import { fmt } from '../../lib/portfolio';

const shortM = iso => new Date(iso + 'T00:00:00Z').toLocaleDateString('en-IN', { month: 'short', year: '2-digit' });

const SparkTip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const p = payload[0].payload;
  return (
    <div style={{ background: '#1a1a2e', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '7px', padding: '5px 9px', fontSize: '11px' }}>
      <span style={{ color: 'rgba(255,255,255,0.55)' }}>{shortM(p.month)} · </span>
      <span style={{ color: '#f5f0e8', fontWeight: 600 }}>{fmt(p.value)}</span>
    </div>
  );
};

export default function EntityCard({ label, value, usdValue, sparkData = [], color = '#4da6ff', glow = 'rgba(77,166,255,0.18)' }) {
  const gid = `ent-${label.replace(/[^a-z]/gi, '')}`;
  const firstRender = useRef(true);
  useEffect(() => { firstRender.current = false; }, []);
  return (
    <div
      className="dash-card relative rounded-2xl p-5 overflow-hidden"
      style={{
        background: 'var(--card-grad)',
        border: '1px solid var(--card-border)',
        boxShadow: 'var(--card-shadow)',
        backdropFilter: 'blur(14px)',
        '--card-accent': color, '--card-accent-glow': glow,
      }}
    >
      <div className="card-glow" style={{ position: 'absolute', top: '-50px', right: '-30px', width: '200px', height: '160px', borderRadius: '50%', background: `radial-gradient(circle, ${glow} 0%, transparent 70%)`, pointerEvents: 'none', opacity: 0.85 }} />
      <p className="relative font-semibold mb-2" style={{ color: 'var(--text-dim)', fontSize: '16px' }}>{label}</p>
      <p className="relative font-bold tabular-nums font-display mb-0.5" style={{ color: 'var(--text)', fontSize: '30px' }}>{value}</p>
      <p className="relative font-semibold mb-2" style={{ color, fontSize: '15px' }}>{usdValue}</p>
      {sparkData.length > 1 && (
        <div className="relative" style={{ height: '44px', marginLeft: '-6px', marginRight: '-6px' }}>
          <ResponsiveContainer width="100%" height="100%">
            <AreaChart data={sparkData} margin={{ top: 4, right: 6, bottom: 0, left: 6 }}>
              <defs>
                <linearGradient id={gid} x1="0" y1="0" x2="0" y2="1">
                  <stop offset="0%" stopColor={color} stopOpacity={0.3} />
                  <stop offset="100%" stopColor={color} stopOpacity={0} />
                </linearGradient>
              </defs>
              <Tooltip content={<SparkTip />} cursor={{ stroke: color, strokeWidth: 1, strokeDasharray: '3 3' }} />
              <Area type="monotone" dataKey="value" stroke={color} strokeWidth={2} fill={`url(#${gid})`} dot={false} isAnimationActive={firstRender.current} animationDuration={800} animationEasing="ease-out" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
